import { AddCircle } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import {
  Divider,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Theme,
} from '../../index';
import { DraggableListItemProps } from './models/transferListProps.types';

const useStyles = makeStyles((theme: Theme) => ({
  listItem: {
    backgroundColor: 'inherit',
  },
  listItemAdded: {
    backgroundColor: theme.palette.primary.light,
  },
  itemTitle: {
    cursor: 'pointer',
    padding: theme.spacing(1, 0),
  },
}));

export const DraggableListItem = ({ item, addItem, itemIcon }: DraggableListItemProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div data-testid={'DraggableListItem-component'}>
      <ListItem className={clsx(classes.listItem)}>
        {itemIcon && <ListItemAvatar style={{ position: 'relative', top: 2, minWidth: 0 }}>{itemIcon}</ListItemAvatar>}
        <ListItemText tabIndex={0} className={classes.itemTitle} primary={item.title} data-testid={'item-draggable'} />
        <ListItemSecondaryAction>
          <IconButton
            color="primary"
            edge="end"
            aria-label="Add Clause"
            data-testid={`add-item-button`}
            onClick={() => addItem(item)}
          >
            <AddCircle />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      <Divider variant="fullWidth" />
    </div>
  );
};
